import { BaseDiv, Heading1 } from '@cmctechnology/webinvest-design-system';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { EtfHeatMap, StockHeatMap, TipRanksNews, TradingViewDisclaimer, TradingViewScreener } from '../Modules';

const Container = styled(BaseDiv)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: ${({ theme }) => theme.eoraSpaces.xlarge};
`;

const TipRanksNewsContainer = styled(Container)`
  height: 1750px;
  background-color: ${({ theme }) => theme.colours.eoraBrandColours.MODE.BRAND_FALCON_INVEST.WL_APPLICATION_BODY_COLOR_BACKGROUND};
`;

export type GenericWidgetType = 'stockHeatmap' | 'etfHeatmap' | 'TipRanksNews' | 'TradingViewScreener';

export const GenericWidgetContainer: React.FC<{ genericWidgetType: GenericWidgetType }> = ({ genericWidgetType }) => {
  const { t } = useTranslation();

  const titleMap: Record<GenericWidgetType, string> = {
    stockHeatmap: t('Stock Heatmap'),
    etfHeatmap: t('ETF Heatmap'),
    TipRanksNews: t('TipRanks News'),
    TradingViewScreener: t('Screener')
  };

  if (genericWidgetType === 'TipRanksNews') {
    return (
      <TipRanksNewsContainer>
        <Heading1>{titleMap[genericWidgetType]}</Heading1>
        <TipRanksNews isFullScreen />
      </TipRanksNewsContainer>
    );
  }

  return (
    <Container>
      <Heading1>{titleMap[genericWidgetType]}</Heading1>
      {genericWidgetType === 'stockHeatmap' && <StockHeatMap isFullScreen />}
      {genericWidgetType === 'etfHeatmap' && <EtfHeatMap isFullScreen />}
      {genericWidgetType === 'TradingViewScreener' && <TradingViewScreener id='screener' isFullScreen />}
      <TradingViewDisclaimer />
    </Container>
  );
};
